import { useContext } from "react";

import { Context } from "./_context";
import type { TemplateVariableDefinitions } from "./definitions";

export function useTemplateVariables(): TemplateVariableDefinitions {
	return useContext(Context);
}
